import { useQueryClient } from '@tanstack/vue-query';
import useUpdateCartQuantityMutation from '../api/useUpdateCartQuantityMutation';

export default function useUpdateCartQuantity() {
  const { mutate, ...state } = useUpdateCartQuantityMutation();
  const queryClient = useQueryClient();

  const updateCartQuantity = (itemId, quantity, onSettled) => {
    mutate({ itemId, quantity }, {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['cart'], exact: true });
        queryClient.invalidateQueries({ queryKey: ['user'], exact: true });
      },
      onSettled: () => {
        if (onSettled) onSettled();
      },
    });
  };

  return {
    isLoading: state.isPending,
    updateCartQuantity,
  };
}
